import {
  Dialog,
  DialogTitle,
  TextField,
  DialogActions,
  DialogContent,
  Button,
} from "@mui/material";
import Swal from "sweetalert2";
import "./../../bibliotecacomponents/crearSubcategoriaDewey/crearSubcategoriaDewey.css";
import { useState } from "react";

export function CreateGenre({
  onAdd,
  title,
  confirmationText,
  actionFunction,
  isOpen,
  setIsOpen,
  generoField,
  setGeneroField,
}) {
  const handleCrearGenero = async () => {
    try {
      await actionFunction({ nombre: generoField });
      onAdd(generoField);
      setIsOpen(false);
      Swal.fire({
        title: "Éxito!",
        customClass: {
          container: "subcategory-modal",
          popup: "subcategory-modal",
        },
        text: "El género se ha guardado con éxito.",
        icon: "success",
        confirmButtonText: "Ok",
        confirmButtonColor: "#21807C",
      });
    } catch (error) {
      setIsOpen(false);
      Swal.fire({
        title: "Error!",
        customClass: {
          container: "subcategory-modal",
          popup: "subcategory-modal",
        },
        text: "No se pudo guardar el género.",
        icon: "error",
        confirmButtonText: "Ok",
        confirmButtonColor: "#21807C",
      });
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          name="genero"
          label="Nombre de el género"
          type="text"
          fullWidth
          variant="outlined"
          value={generoField}
          onChange={(e) => setGeneroField(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCrearGenero} color="success">
          {confirmationText}
        </Button>
        <Button
          onClick={() => {
            setIsOpen(false);
          }}
          color="error"
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
